import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Alert from "react-s-alert";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { Col, Form, Row, Image, InputGroup } from "react-bootstrap";
import {
  FormControl,
  Select,
  InputLabel,
  IconButton,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import isEmpty from "../../../../../../../store/validation/is-Empty";
import InputNumberFunc from "../../../../../../../function/InputNumberFunc";
import LeftSideNavigation from "../../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../../navigationSection/BottomNavigationMobile";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../../store/actions/authAction";
import { update_new_subscription_taxes_data } from "../../../../../../../store/actions/authAction";
import { update_ordering_subscription_taxes } from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";

export const EditFastFoodGeneralSettingsTaxes = (props) => {
  let history = useHistory();
  const [state, setState] = useState({
    salesOtherTax: "Menu Price Already Includes Taxes",
    code: "",
    description: "",
    category: "",
    taxNameArr: [],
    editkey: false,
    editkeyText: "",

    tax_name: "",
    categoryDescription: "",
    tax_value: "PERCENTAGE",
    take_away: "",
    curb_side: "",
    skip_line: "",
    catering_banquet: "",
    home_delivery: "",
    taxSurchargesArr: [],
    taxSurchargesKey: false,
    taxSurchargesText: "",
    staticId: "",
    errors: {},
    flatCharges: false,
  });
  const [active, setActive] = useState(1);

  const selecthandleChange = (e) => {
    // console.log(state.taxNameArr);
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const descriptionHandleChange = (e) => {
    let taxName = state.taxNameArr;
    let description = e.target.value.split(" ").join("");
    let data = taxName.find(
      (data) =>
        (data.code + "-" + data.description + data.category)
          .split(" ")
          .join("") === description
    );
    setState({
      ...state,
      [e.target.name]: e.target.value,
      staticId: data.id,
    });
  };

  const handleTextPORV = (e) => {
    // const taxSurchargesArrData = state.taxSurchargesArr;
    // if (
    //   taxSurchargesArrData.some(
    //     (data) => data.tax_value === "INR" || data.tax_value === "PERCENTAGE"
    //   )
    // ) {
    //   Alert.error(`<h4>You can not modified</h4>`, {
    //     position: "top-right",
    //     effect: "bouncyflip",
    //     beep: true,
    //     html: true,
    //     timeout: 3000,
    //     offset: 35,
    //   });
    // } else {
    setActive(e);
    setState({
      ...state,
      tax_value: e === 1 ? "PERCENTAGE" : "VALUE",
    });
    // }
  };

  const [showTaxSurcharges, setShowTaxSurcharges] = useState(false);
  const handleShowTaxSurcharges = () => {
    setShowTaxSurcharges({
      showTaxSurcharges: !showTaxSurcharges,
    });
  };

  /*******************************
   * Add Tax Name Action
   ******************************/
  const addTaxNameAction = (e) => {
    e.preventDefault();
    let taxNameArrary = state.taxNameArr;
    let alreadyPresentCode = state.code;
    let alreadyPresentDescription = state.description;
    // let alreadyPresentCategory = state.category;
    // let phoneObj = taxNameArrary.find((data) => data.description === alreadyPresent);
    if (
      state.code === "" ||
      state.description === "" ||
      state.category === ""
    ) {
      Alert.error(`<h4>Please enter a field</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (
      !state.code.replace(/\s/g, "").length ||
      !state.description.replace(/\s/g, "").length ||
      !state.category.replace(/\s/g, "").length
    ) {
      Alert.error(`<h4>Please enter a field</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      if (taxNameArrary.some((data) => data.code === alreadyPresentCode)) {
        Alert.error(`<h4>${alreadyPresentCode} already present</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else if (
        taxNameArrary.some(
          (data) => data.description === alreadyPresentDescription
        )
      ) {
        Alert.error(`<h4>${alreadyPresentDescription} already present</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        if (taxNameArrary.length === 0) {
          let contactData = {
            id: 1,
            code: state.code,
            description: state.description,
            category: state.category,
          };
          taxNameArrary.push(contactData);
          setState({
            ...state,
            taxNameArr: taxNameArrary,
            code: "",
            description: "",
            category: "",
          });
        } else {
          let id = taxNameArrary[taxNameArrary.length - 1].id;
          let contactData = {
            id: id + 1,
            code: state.code,
            description: state.description,
            category: state.category,
          };
          taxNameArrary.push(contactData);
          setState({
            ...state,
            taxNameArr: taxNameArrary,
            code: "",
            description: "",
            category: "",
          });
        }
      }
    }
  };

  // const addCodeOnSuccess = () => {
  //   setState({
  //     ...state,
  //     code: "",
  //     description: "",
  //     category: "",
  //   });
  // };

  /*************************************
   * @DESC Tax Name Change Handlers
   ************************************/
  // const onTaxNameChangeHandler = (e) => {
  //   setState({
  //     ...state,
  //     [e.target.name]: e.target.value,
  //     errors: {},
  //   });
  // };
  const onTaxNameChangeHandler = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    setState({
      ...state,
      [e.target.name]: number,
    });
  };

  /******************************
   * ONEDIT BUTTON HANDLER
   ******************************/
  const onEditButtonCLickHandler = (id) => {
    let contacts_array = state.taxNameArr;
    let phoneObj = contacts_array.find((phone) => phone.id === id);
    let indexOf = contacts_array.indexOf(phoneObj);
    let contactData = {
      id: id,
      code: state.code,
      description: state.description,
      category: state.category,
    };
    let to_be_set = contacts_array[indexOf];
    contacts_array.splice(indexOf, 1);
    contacts_array.push(contactData);
    setState({
      ...state,
      editkey: true,
      editkeyText: id,
      taxNameArr: contacts_array,
      ...to_be_set,
    });
  };

  const updateSaveButton = (e) => {
    e.preventDefault();
    let contacts_array = state.taxNameArr;
    let alreadyPresent = state.description;
    // let phoneObj = taxNameArrary.find((data) => data.description === alreadyPresent);
    if (contacts_array.some((data) => data.description === alreadyPresent)) {
      Alert.error(`<h4>${alreadyPresent} already present</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      let contactData = {
        id: contacts_array.length + 1,
        code: state.code,
        description: state.description,
        category: state.category,
      };
      let to_be_set = contacts_array[contacts_array.length - 1];
      let to_be_displayed = contacts_array;
      to_be_displayed.splice(contacts_array.length - 1, 1);
      to_be_displayed.push(contactData);
      setState({
        ...state,
        taxNameArr: contacts_array,
        editkey: false,
        editkeyText: "",
        ...to_be_set,
        code: "",
        description: "",
        category: "",
      });
    }
  };

  /*************************************
   * @DESC Remove TaxName Change Handlers
   ************************************/
  const removeTaxNameAction = (id) => {
    let taxName = state.taxNameArr;
    let keywordsObj = taxName.find((images) => images.id === id);
    if (keywordsObj === 0 || keywordsObj) {
      taxName.splice(taxName.indexOf(keywordsObj), 1);
      setState({
        ...state,
        taxNameArr: taxName,
      });
    }
  };

  /*******************************
   * Add Tax Surcharges Action
   ******************************/
  const AddTaxSurcharges = (e) => {
    e.preventDefault();
    let taxNameArrary = state.taxSurchargesArr;
    let alreadyPresent = state.categoryDescription;
    // let phoneObj = taxNameArrary.find((data) => data.categoryDescription === alreadyPresent);
    if (
      alreadyPresent === undefined ||
      alreadyPresent === null ||
      alreadyPresent === ""
    ) {
      Alert.error(`<h4>Please enter category description</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (
      taxNameArrary.some((data) => data.categoryDescription === alreadyPresent)
    ) {
      Alert.error(`<h4>${alreadyPresent} already present</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      if (taxNameArrary.length === 0) {
        let contactData = {
          id: state.staticId,
          tax_name: state.categoryDescription,
          flatCharges: state.flatCharges,
          categoryDescription: state.categoryDescription,
          code: state.categoryDescription.substr(0, 4),
          tax_value: state.tax_value,
          take_away: state.take_away,
          curb_side: state.curb_side,
          skip_line: state.skip_line,
          catering_banquet: state.catering_banquet,
          home_delivery: state.home_delivery,
        };
        taxNameArrary.push(contactData);
        setState({
          ...state,
          taxSurchargesArr: taxNameArrary,
          staticId: "",
          tax_name: "",
          categoryDescription: "",
          tax_value: state.tax_value,
          code: "",
          take_away: "",
          curb_side: "",
          skip_line: "",
          catering_banquet: "",
          home_delivery: "",
          taxSurchargesText: "",
        });
      } else {
        let id = taxNameArrary[taxNameArrary.length - 1].id;
        let contactData = {
          id: state.staticId,
          tax_name: state.categoryDescription,
          flatCharges: state.flatCharges,
          categoryDescription: state.categoryDescription,
          code: state.categoryDescription.substr(0, 4),
          tax_value: state.tax_value,
          take_away: state.take_away,
          curb_side: state.curb_side,
          skip_line: state.skip_line,
          catering_banquet: state.catering_banquet,
          home_delivery: state.home_delivery,
        };
        taxNameArrary.push(contactData);
        setState({
          ...state,
          taxSurchargesArr: taxNameArrary,
          staticId: "",
          tax_name: "",
          categoryDescription: "",
          tax_value: state.tax_value,
          code: "",
          take_away: "",
          curb_side: "",
          skip_line: "",
          catering_banquet: "",
          home_delivery: "",
          taxSurchargesText: "",
        });
      }
    }
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  const onChange = (e, type) => {
    if (type === "PERCENTAGE") {
      let { value, min, max, maxLength } = e.target;
      value =
        Math.max(Number(min), Math.min(Number(max), Number(value))) ||
        value.slice(0, maxLength);
      setState({
        ...state,
        [e.target.name]: value,
      });
    } else {
      const { value, maxLength } = e.target;
      const number = value.slice(0, maxLength);
      setState({
        ...state,
        [e.target.name]: number,
      });
    }
  };

  /******************************
   * ONEDIT BUTTON HANDLER
   ******************************/
  const onEditTaxAndSurcharges = (id) => {
    let contacts_array = state.taxSurchargesArr;
    let phoneObj = contacts_array.find((phone) => phone.id === id);
    let indexOf = contacts_array.indexOf(phoneObj);
    let contactData = {
      id: id,
      tax_name: state.categoryDescription,
      categoryDescription: state.categoryDescription,
      code: state.categoryDescription.substr(0, 4),
      tax_value: state.tax_value,
      take_away: state.take_away,
      curb_side: state.curb_side,
      skip_line: state.skip_line,
      flatCharges: state.flatCharges || false,
      catering_banquet: state.catering_banquet,
      home_delivery: state.home_delivery,
    };
    let to_be_set = contacts_array[indexOf];
    contacts_array.splice(indexOf, 1);
    contacts_array.push(contactData);
    setState({
      ...state,
      taxSurchargesKey: true,
      taxSurchargesText: id,
      taxSurchargesArr: contacts_array,
      flatCharges: state?.flatCharges || false,
      ...to_be_set,
    });
  };

  const updateAddTaxesSercharges = (e) => {
    e.preventDefault();
    // let taxNameTextVr = state.taxName;
    // let taxNameArr = state.taxNameArr;
    let contacts_array = state.taxSurchargesArr;
    let alreadyPresent = state.tax_name;
    // let phoneObj = taxNameArrary.find((data) => data.description === alreadyPresent);
    if (contacts_array.some((data) => data.tax_name === alreadyPresent)) {
      Alert.error(`<h4>${alreadyPresent} already present</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      let contactData = {
        id: state.taxSurchargesText,
        tax_name: state.tax_name,
        categoryDescription: state.tax_name,
        code: state.categoryDescription.substr(0, 4),
        tax_value: state.tax_value,
        take_away: state.take_away,
        curb_side: state.curb_side,
        skip_line: state.skip_line,
        flatCharges: state.flatCharges,
        catering_banquet: state.catering_banquet,
        home_delivery: state.home_delivery,
      };
      let to_be_set = contacts_array[contacts_array.length - 1];
      let to_be_displayed = contacts_array;
      to_be_displayed.splice(contacts_array.length - 1, 1);
      to_be_displayed.push(contactData);
      console.log(contacts_array);
      setState({
        ...state,
        taxSurchargesArr: contacts_array,
        taxSurchargesKey: false,
        taxSurchargesText: "",
        ...to_be_set,
        tax_name: "",
        categoryDescription: "",
        code: "",
        tax_value: "",
        take_away: "",
        curb_side: "",
        skip_line: "",
        catering_banquet: "",
        home_delivery: "",
      });
    }
  };

  /*************************************
   * @DESC Remove TaxName Change Handlers
   ************************************/
  const removeAddTaxSurcharges = (id) => {
    let contacts_array = state.taxSurchargesArr;
    let emailObj = contacts_array.find((email) => email.id === id);
    if (emailObj === 0 || emailObj) {
      contacts_array.splice(contacts_array.indexOf(emailObj), 1);
      setState({
        ...state,
        taxSurchargesArr: contacts_array,
      });
    }
  };

  const INR = <i className="fa fa-inr" aria-hidden="true"></i>;

  const handleSubmit = (e) => {
    let valueData = {
      value: state.taxSurchargesArr.length > 0 ? true : false,
      menu_price_include_price:
        state.salesOtherTax === "Menu Price Already Includes Taxes"
          ? true
          : false,
      add_tax_on_price:
        state.salesOtherTax === "Apply Taxes on Top of Menu Price"
          ? true
          : false,
      tax_code: state.taxNameArr,
      tax_values: state.taxSurchargesArr,
    };
    const token = props.auth.user.accessToken;
    const subscriptionId = props.subscription._id;
    let formData = props.allSubscriptionsData;
    formData.fast_food_dining_status.ordering.order_general = valueData;
    props.update_new_subscription_taxes_data(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  const onSuccess = (data) => {
    let totlaChange =
      data?.fast_food_dining_status?.ordering?.order_general?.tax_values;
    let take_away_charges = [];
    let curb_side_charges = [];
    let skip_line_charges = [];
    let dine_in_charges = [];
    let catering_banquet_charges = [];
    let home_delivery_charges = [];
    /*******************
     * @DESC Take Away
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].take_away !== undefined &&
        totlaChange[i].take_away !== null
      ) {
        take_away_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].take_away,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Curb Side
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].curb_side !== undefined &&
        totlaChange[i].curb_side !== null
      ) {
        curb_side_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].curb_side,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Skip Line
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].skip_line !== undefined &&
        totlaChange[i].skip_line !== null
      ) {
        skip_line_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].skip_line,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Dine In
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].dine_in_order !== undefined &&
        totlaChange[i].dine_in_order !== null
      ) {
        dine_in_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].dine_in_order,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Catering Banquet
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].catering_banquet !== undefined &&
        totlaChange[i].catering_banquet !== null
      ) {
        catering_banquet_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].catering_banquet,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Home Delivery
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].home_delivery !== undefined &&
        totlaChange[i].home_delivery !== null
      ) {
        home_delivery_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].home_delivery,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    const token = props.auth.user.accessToken;
    let formData = {
      category: {
        charges: totlaChange,
      },
      Items: {
        take_away: {
          sur_charges: take_away_charges,
        },
        curb_side: {
          sur_charges: curb_side_charges,
        },
        skip_line: {
          sur_charges: skip_line_charges,
        },
        dine_in: {
          sur_charges: dine_in_charges,
        },
        catering_banquet: {
          sur_charges: catering_banquet_charges,
        },
        home_delivery: {
          sur_charges: home_delivery_charges,
        },
      },
    };
    props.update_ordering_subscription_taxes(
      formData,
      token,
      false,
      "",
      onSuccessTaxes(),
      (err) => onErrorTaxes(err)
    );
  };

  const onSuccessTaxes = (e) => {
    Alert.success("<h4>General taxes changes update successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/edit-ordering-fastfood-subscription");
  };

  const onErrorTaxes = (err) => {
    Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  // const onSuccess = (e) => {
  //   Alert.success("<h4>General Taxes changes add successfully</h4>", {
  //     position: "top-right",
  //     effect: "bouncyflip",
  //     beep: true,
  //     html: true,
  //     timeout: 3000,
  //     offset: 35,
  //   });
  //   history.push("/edit-ordering-fastfood-subscription");
  // };

  useEffect(() => {
    setState({
      ...state,
      salesOtherTax:
        props.subscriptionData &&
        props.subscriptionData.add_tax_on_price === true
          ? "Apply Taxes on Top of Menu Price"
          : "Menu Price Already Includes Taxes",
      taxSurchargesArr:
        props.subscriptionData && props.subscriptionData.tax_values,
      taxNameArr: props.subscriptionData && props.subscriptionData.tax_code,
      taxSurchargesText: "",
    });
  }, [props.subscriptionData]);

  useEffect(() => {
    if (state.flatCharges) {
      handleTextPORV(2);
    }
  }, [state.flatCharges]);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>

          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation
              leftText="vendorReview"
              backButtonLink="/edit-ordering-fastfood-subscription"
              displayText="Back"
            />
            <div className="col-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
              <div className="mb-4">
                <TopTextReusableComponent
                  headingText="Order General Settings, Taxes & Surcharges"
                  headingParagraph="(Please note: You have to add settings for all relevant order type before maintaining rates, if you enable a n ew order type then you have to come back and maintain these settings)"
                  displayEdit={state.editButton}
                  // onClickEdit={editClick}
                />
              </div>
              <div>
                <Row className="align-items-center py-4">
                  <Col md={5}>
                    <div className="f14-700">Sales and Other Tax Info</div>
                  </Col>
                  <Col md={7}>
                    <FormControl variant="outlined" className={"w-100"}>
                      <Select
                        value={state.salesOtherTax}
                        onChange={selecthandleChange}
                        inputProps={{
                          name: "salesOtherTax",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value={"Menu Price Already Includes Taxes"}>
                          Menu Price Already Includes Taxes
                        </MenuItem>
                        <MenuItem value={"Apply Taxes on Top of Menu Price"}>
                          Apply Taxes on Top of Menu Price
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                {/* {state.salesOtherTax === "Apply Taxes on Top of Menu Price" ? ( */}
                <React.Fragment>
                  <Row className="align-items-center py-4">
                    <Col md={4} className="align-self-baseline">
                      <div className="f14-700" style={{ marginTop: 12 }}>
                        Code of the Tax / Surcharge
                      </div>
                    </Col>
                    <Col md={8}>
                      <div className="row">
                        <div className="col-3">
                          <NewInputText
                            extraClass="mb-1"
                            name="code"
                            onChange={onTaxNameChangeHandler}
                            value={state.code}
                            labelText="Code"
                            maxLength={6}
                          />
                          <div className="pho_14_regular text-red">
                            {state.errors && state.errors.code}
                          </div>
                        </div>
                        <div className="col-5 p-0">
                          <NewInputText
                            extraClass="mb-1"
                            name="description"
                            onChange={onTaxNameChangeHandler}
                            value={state.description}
                            labelText="Description"
                            maxLength={32}
                          />
                          <div className="pho_14_regular text-red">
                            {state.errors && state.errors.description}
                          </div>
                        </div>
                        <div className="col-4">
                          <FormControl variant="outlined" className={"w-100"}>
                            <InputLabel htmlFor="outlined-description">
                              Category
                            </InputLabel>
                            <Select
                              value={state.category}
                              onChange={selecthandleChange}
                              label="Category"
                              name="category"
                              id="outlined-description"
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <MenuItem value="surcharge">Surcharges</MenuItem>
                              {state.salesOtherTax ===
                              "Apply Taxes on Top of Menu Price" ? (
                                <MenuItem value="tax">Tax</MenuItem>
                              ) : null}
                              <MenuItem value="packaging">Packaging</MenuItem>
                              <MenuItem value="packaging">Delivery</MenuItem>
                              <MenuItem value="others">Others</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      {state.editkey ? (
                        <button
                          className={
                            "mt-3 add-button-icon-reusable add-button-icon-reusable-blue"
                          }
                          onClick={updateSaveButton}
                        >
                          Update
                        </button>
                      ) : (
                        <button
                          className={
                            "mt-3 add-button-icon-reusable add-button-icon-reusable-blue"
                          }
                          onClick={addTaxNameAction}
                        >
                          Add Tax/ Surcharge Category
                        </button>
                      )}
                      <hr />
                      <div className="row mb-2">
                        <div className="col-2">
                          <div className="f14-700">Code</div>
                        </div>
                        <div className="col-4">
                          <div className="f14-700">Description</div>
                        </div>
                        <div className="col-3">
                          <div className="f14-700">Category</div>
                        </div>
                        <div className="col-3">
                          <div className="f14-700">Action</div>
                        </div>
                      </div>

                      {state.taxNameArr &&
                        state.taxNameArr.map((data, index) => {
                          return (
                            <React.Fragment key={index}>
                              <div className="row mt-3 mb-3">
                                <div className="col-2 text-capitalize f11-500">
                                  {data.code}
                                </div>
                                <div className="col-4 text-capitalize f11-500">
                                  {data.description}
                                </div>
                                <div className="col-3 text-capitalize f11-500">
                                  {data.category}
                                </div>
                                <div className="col-3">
                                  {state.editkeyText === "" ? (
                                    <div className="d-flex">
                                      <IconButton
                                        className="mr-2 p-0"
                                        onClick={(e) =>
                                          onEditButtonCLickHandler(data.id)
                                        }
                                      >
                                        <Image
                                          src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                          alt="add"
                                          title="add"
                                          style={{ width: "20px" }}
                                        />
                                      </IconButton>
                                      <IconButton
                                        className="p-0"
                                        onClick={(e) =>
                                          removeTaxNameAction(data.id)
                                        }
                                      >
                                        <Image
                                          src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                          alt="delete"
                                          title="delete"
                                          style={{ width: "20px" }}
                                        />
                                      </IconButton>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                    </Col>
                  </Row>
                  <Row className="align-items-center py-4">
                    <Col md={5}>
                      <div className="f14-700 pb-1">
                        Maintain Tax/Surcharges to Order Types
                      </div>
                      <div className="f10-400 opacity5">
                        Order Types Below will be listed based on your
                        subscriptions enabled
                      </div>
                    </Col>
                    <Col md={7}>
                      <Form noValidate onSubmit={AddTaxSurcharges}>
                        <div className="enGrayBorderBox p-3">
                          <FormControl variant="outlined" className={"w-100"}>
                            <InputLabel htmlFor="outlined-description">
                              Description of New Tax Category
                            </InputLabel>
                            <Select
                              value={state.categoryDescription}
                              onChange={descriptionHandleChange}
                              label="Description of New Tax Category"
                              name="categoryDescription"
                              id="outlined-description"
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {!isEmpty(state.taxNameArr) &&
                                state.taxNameArr.map((allData, index) => {
                                  return (
                                    <MenuItem
                                      key={index}
                                      value={
                                        allData.code +
                                        " - " +
                                        allData.description +
                                        " " +
                                        allData.category
                                      }
                                    >
                                      {allData.code +
                                        " - " +
                                        allData.description +
                                        " " +
                                        allData.category}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                          <div className="f9-400 opacity5">
                            Order Types Below will be listed based on your
                            subscriptions enabled
                          </div>
                          <div className="d-flex justify-content-between pb-3 align-items-center">
                            <div className="d-flex align-items-center">
                              <div>
                                <input
                                  type="checkbox"
                                  name="flatCharges"
                                  checked={state.flatCharges}
                                  onChange={() =>
                                    setState({
                                      ...state,
                                      flatCharges: !state.flatCharges,
                                    })
                                  }
                                />
                              </div>
                              <div>
                                <label className="f14-500 ml-3">
                                  <span className="">Flat Charge</span>
                                </label>
                              </div>
                            </div>
                            <div className="btnGroup2">
                              {!state.flatCharges && (
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV(1)}
                                  className={`${active === 1 ? "active" : ""}`}
                                >
                                  %
                                </button>
                              )}
                              <button
                                type="button"
                                onClick={() => handleTextPORV(2)}
                                className={`${active === 2 ? "active" : ""}`}
                              >
                                {INR}
                              </button>
                            </div>
                          </div>
                          {props.orderingData &&
                          props.orderingData.take_away &&
                          props.orderingData.take_away.value ? (
                            <div className="d-flex justify-content-between pb-3 align-items-center">
                              <div className="f14-500">Take Away</div>
                              <div>
                                <InputGroup className="enInputwithText d-table">
                                  <input
                                    // onKeyPress={(event) => {
                                    //   if (!/[0-9]/.test(event.key)) {
                                    //     event.preventDefault();
                                    //   }
                                    // }}
                                    type="number"
                                    name="take_away"
                                    onChange={(e) =>
                                      onChange(
                                        e,
                                        active === 1 ? "PERCENTAGE" : "VALUE"
                                      )
                                    }
                                    // onKeyDown={InputNumberFunc}
                                    value={state.take_away}
                                    maxLength={active === 1 ? 3 : 5}
                                    min={active === 1 ? "0" : null}
                                    max={active === 1 ? "100" : null}
                                    className="d-table-cell"
                                  />
                                  <InputGroup.Prepend className="d-table-cell">
                                    <InputGroup.Text>
                                      {active === 1 ? "%" : INR}
                                    </InputGroup.Text>
                                  </InputGroup.Prepend>
                                </InputGroup>
                              </div>
                            </div>
                          ) : null}
                          {props.orderingData &&
                          props.orderingData.cubside_delivery &&
                          props.orderingData.cubside_delivery.value ? (
                            <div className="d-flex justify-content-between pb-3 align-items-center">
                              <div className="f14-500">Curb Side</div>
                              <div>
                                <InputGroup className="enInputwithText d-table">
                                  <input
                                    // onKeyPress={(event) => {
                                    //   if (!/[0-9]/.test(event.key)) {
                                    //     event.preventDefault();
                                    //   }
                                    // }}
                                    type="number"
                                    name="curb_side"
                                    onChange={(e) =>
                                      onChange(
                                        e,
                                        active === 1 ? "PERCENTAGE" : "VALUE"
                                      )
                                    }
                                    // onKeyDown={InputNumberFunc}
                                    value={state.curb_side}
                                    maxLength={active === 1 ? 3 : 5}
                                    min={active === 1 ? "0" : null}
                                    max={active === 1 ? "100" : null}
                                    className="d-table-cell"
                                  />
                                  <InputGroup.Prepend className="d-table-cell">
                                    <InputGroup.Text>
                                      {active === 1 ? "%" : INR}
                                    </InputGroup.Text>
                                  </InputGroup.Prepend>
                                </InputGroup>
                              </div>
                            </div>
                          ) : null}
                          {props.orderingData &&
                          props.orderingData.self_serve &&
                          props.orderingData.self_serve.value ? (
                            <div className="d-flex justify-content-between pb-3 align-items-center">
                              <div className="f14-500">Skip the line</div>
                              <div>
                                <InputGroup className="enInputwithText d-table">
                                  <input
                                    // onKeyPress={(event) => {
                                    //   if (!/[0-9]/.test(event.key)) {
                                    //     event.preventDefault();
                                    //   }
                                    // }}
                                    type="number"
                                    name="skip_line"
                                    onChange={(e) =>
                                      onChange(
                                        e,
                                        active === 1 ? "PERCENTAGE" : "VALUE"
                                      )
                                    }
                                    // onKeyDown={InputNumberFunc}
                                    value={state.skip_line}
                                    maxLength={active === 1 ? 3 : 5}
                                    min={active === 1 ? "0" : null}
                                    max={active === 1 ? "100" : null}
                                    className="d-table-cell"
                                  />
                                  <InputGroup.Prepend className="d-table-cell">
                                    <InputGroup.Text>
                                      {active === 1 ? "%" : INR}
                                    </InputGroup.Text>
                                  </InputGroup.Prepend>
                                </InputGroup>
                              </div>
                            </div>
                          ) : null}
                          {props.orderingData &&
                          props.orderingData.catering_banquet &&
                          props.orderingData.catering_banquet.value ? (
                            <div className="d-flex justify-content-between pb-3 align-items-center">
                              <div className="f14-500">
                                Catering and Banquet
                              </div>
                              <div>
                                <InputGroup className="enInputwithText d-table">
                                  <input
                                    // onKeyPress={(event) => {
                                    //   if (!/[0-9]/.test(event.key)) {
                                    //     event.preventDefault();
                                    //   }
                                    // }}
                                    type="number"
                                    name="catering_banquet"
                                    onChange={(e) =>
                                      onChange(
                                        e,
                                        active === 1 ? "PERCENTAGE" : "VALUE"
                                      )
                                    }
                                    // onKeyDown={InputNumberFunc}
                                    value={state.catering_banquet}
                                    maxLength={active === 1 ? 3 : 5}
                                    min={active === 1 ? "0" : null}
                                    max={active === 1 ? "100" : null}
                                    className="d-table-cell"
                                  />
                                  <InputGroup.Prepend className="d-table-cell">
                                    <InputGroup.Text>
                                      {active === 1 ? "%" : INR}
                                    </InputGroup.Text>
                                  </InputGroup.Prepend>
                                </InputGroup>
                              </div>
                            </div>
                          ) : null}
                          {props.orderingData &&
                          props.orderingData.my_seat_table_order &&
                          props.orderingData.my_seat_table_order.value ? (
                            <div className="d-flex justify-content-between pb-3 align-items-center">
                              <div className="f14-500">My Seat Table Order</div>
                              <div>
                                <InputGroup className="enInputwithText d-table">
                                  <input
                                    // onKeyPress={(event) => {
                                    //   if (!/[0-9]/.test(event.key)) {
                                    //     event.preventDefault();
                                    //   }
                                    // }}
                                    type="number"
                                    name="home_delivery"
                                    onChange={(e) =>
                                      onChange(
                                        e,
                                        active === 1 ? "PERCENTAGE" : "VALUE"
                                      )
                                    }
                                    // onKeyDown={InputNumberFunc}
                                    value={state.home_delivery}
                                    maxLength={active === 1 ? 3 : 5}
                                    min={active === 1 ? "0" : null}
                                    max={active === 1 ? "100" : null}
                                    className="d-table-cell"
                                  />
                                  <InputGroup.Prepend className="d-table-cell">
                                    <InputGroup.Text>
                                      {active === 1 ? "%" : INR}
                                    </InputGroup.Text>
                                  </InputGroup.Prepend>
                                </InputGroup>
                              </div>
                            </div>
                          ) : null}
                          <div className="d-flex justify-content-end">
                            {/* <ReusableOnboardingLink
                                buttonTitle="Back Button"
                                buttonClass="btn-xs onboarding_button_link_reusable onboarding_button_link_reusable_white"
                                buttonText="Back"
                                link="/edit-ordering-fastfood-subscription"
                              /> */}

                            {state.taxSurchargesKey ? (
                              <ReusableOnboardingButton
                                buttonTitle="Edit Button"
                                buttonClass="btn-xs onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                                buttonText="Update"
                                buttonType="button"
                                onClick={updateAddTaxesSercharges}
                              />
                            ) : state.take_away === "" &&
                              state.curb_side === "" &&
                              state.skip_line === "" &&
                              state.catering_banquet === "" &&
                              state.home_delivery === "" ? (
                              <ReusableOnboardingButton
                                buttonTitle="Next Button"
                                buttonClass="btn-xs onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                                buttonText="Save"
                              />
                            ) : (
                              <ReusableOnboardingButton
                                buttonTitle="Next Button"
                                buttonClass="btn-xs onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                                buttonText="Save"
                                buttonType="Submit"
                              />
                            )}
                          </div>
                        </div>
                      </Form>
                    </Col>
                  </Row>
                  <div className="onboarding-map-setup-screen-autodetect-button pt-4">
                    <ReusableOnboardingLink
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      link="/edit-ordering-fastfood-subscription"
                    />
                    <ReusableOnboardingButton
                      buttonTitle="Next Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                      buttonText="Done"
                      buttonType="button"
                      onClick={handleSubmit}
                    />
                  </div>
                </React.Fragment>
                {/* ) : null} */}
              </div>
              {/* {state.salesOtherTax === "Apply Taxes on Top of Menu Price" ? ( */}
              <React.Fragment>
                <div
                  className="d-flex align-items-center text-red f14-500 cursor my-4"
                  onClick={handleShowTaxSurcharges}
                >
                  Show added Tax and Surcharges <KeyboardArrowDownIcon />
                </div>
                {showTaxSurcharges.showTaxSurcharges && (
                  <React.Fragment>
                    {state.taxSurchargesArr &&
                      state.taxSurchargesArr.map((data, index) => {
                        return (
                          <React.Fragment key={index}>
                            <Row
                              className={
                                state.taxSurchargesText === data.id
                                  ? "d-none align-items-center pb-4"
                                  : "align-items-center pb-4"
                              }
                            >
                              <Col md={3}>
                                <div className="f12-500">{data.tax_name}</div>
                              </Col>
                              <Col md={6}>
                                <div className="enGrayBorderBox p-3">
                                  {props.orderingData &&
                                  props.orderingData.take_away &&
                                  props.orderingData.take_away.value ? (
                                    <div className="d-flex justify-content-between pb-3 align-items-center">
                                      <div className="f14-500">Take Away</div>
                                      <div>
                                        <InputGroup className="enInputwithText border-0 rounded-0">
                                          <input
                                            type="number"
                                            value={data.take_away}
                                            disabled
                                          />
                                          <InputGroup.Prepend>
                                            <InputGroup.Text className="border-0 rounded-0">
                                              {data.tax_value === "PERCENTAGE"
                                                ? "%"
                                                : data.tax_value === "VALUE"
                                                ? INR
                                                : null}
                                            </InputGroup.Text>
                                          </InputGroup.Prepend>
                                        </InputGroup>
                                      </div>
                                    </div>
                                  ) : null}
                                  {props.orderingData &&
                                  props.orderingData.cubside_delivery &&
                                  props.orderingData.cubside_delivery.value ? (
                                    <div className="d-flex justify-content-between pb-3 align-items-center">
                                      <div className="f14-500">Curb Side</div>
                                      <div>
                                        <InputGroup className="enInputwithText border-0 rounded-0">
                                          <input
                                            type="number"
                                            value={data.curb_side}
                                            disabled
                                          />
                                          <InputGroup.Prepend>
                                            <InputGroup.Text className="border-0 rounded-0">
                                              {data.tax_value === "PERCENTAGE"
                                                ? "%"
                                                : data.tax_value === "VALUE"
                                                ? INR
                                                : null}
                                            </InputGroup.Text>
                                          </InputGroup.Prepend>
                                        </InputGroup>
                                      </div>
                                    </div>
                                  ) : null}
                                  {props.orderingData &&
                                  props.orderingData.self_serve &&
                                  props.orderingData.self_serve.value ? (
                                    <div className="d-flex justify-content-between pb-3 align-items-center">
                                      <div className="f14-500">
                                        Skip the line
                                      </div>
                                      <div style={{ width: "44%" }}>
                                        <InputGroup className="enInputwithText border-0 rounded-0">
                                          <input
                                            type="number"
                                            value={data.skip_line}
                                            disabled
                                          />
                                          <InputGroup.Prepend>
                                            <InputGroup.Text className="border-0 rounded-0">
                                              {data.tax_value === "PERCENTAGE"
                                                ? "%"
                                                : data.tax_value === "VALUE"
                                                ? INR
                                                : null}
                                            </InputGroup.Text>
                                          </InputGroup.Prepend>
                                        </InputGroup>
                                      </div>
                                    </div>
                                  ) : null}
                                  {props.orderingData &&
                                  props.orderingData.catering_banquet &&
                                  props.orderingData.catering_banquet.value ? (
                                    <div className="d-flex justify-content-between pb-3 align-items-center">
                                      <div className="f14-500">
                                        Catering and Banquet
                                      </div>
                                      <div style={{ width: "44%" }}>
                                        <InputGroup className="enInputwithText border-0 rounded-0">
                                          <input
                                            type="number"
                                            value={data.catering_banquet}
                                            disabled
                                          />
                                          <InputGroup.Prepend>
                                            <InputGroup.Text className="border-0 rounded-0">
                                              {data.tax_value === "PERCENTAGE"
                                                ? "%"
                                                : data.tax_value === "VALUE"
                                                ? INR
                                                : null}
                                            </InputGroup.Text>
                                          </InputGroup.Prepend>
                                        </InputGroup>
                                      </div>
                                    </div>
                                  ) : null}
                                  {props.orderingData &&
                                  props.orderingData.home_delivery &&
                                  props.orderingData.home_delivery.value ? (
                                    <div className="d-flex justify-content-between pb-3 align-items-center">
                                      <div className="f14-500">
                                        Home Delivery
                                      </div>
                                      <div>
                                        <InputGroup className="enInputwithText border-0 rounded-0">
                                          <input
                                            type="number"
                                            value={data.home_delivery}
                                            disabled
                                          />
                                          <InputGroup.Prepend>
                                            <InputGroup.Text className="border-0 rounded-0">
                                              {data.tax_value === "PERCENTAGE"
                                                ? "%"
                                                : data.tax_value === "VALUE"
                                                ? INR
                                                : null}
                                            </InputGroup.Text>
                                          </InputGroup.Prepend>
                                        </InputGroup>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              </Col>
                              <Col md={3}>
                                <div className="f12-400 pb-4">Action</div>
                                <div className="d-flex">
                                  <IconButton
                                    className="mr-4 p-0"
                                    onClick={(e) =>
                                      onEditTaxAndSurcharges(data.id)
                                    }
                                  >
                                    <Image
                                      src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                      alt="add"
                                      title="add"
                                      className="w-20px"
                                    />
                                  </IconButton>
                                  <IconButton
                                    className="p-0"
                                    onClick={(e) =>
                                      removeAddTaxSurcharges(data.id)
                                    }
                                  >
                                    <Image
                                      src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                      alt="add"
                                      title="add"
                                      className="w-20px"
                                    />
                                  </IconButton>
                                </div>
                              </Col>
                            </Row>
                          </React.Fragment>
                        );
                      })}
                  </React.Fragment>
                )}
              </React.Fragment>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

EditFastFoodGeneralSettingsTaxes.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription:
    state.onboarding && state.onboarding.onboard_subscription_details,
  orderingData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status
      .ordering,
  subscriptionData:
    state.onboarding.onboard_subscription_details.fast_food_dining_status &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status
      .ordering &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status
      .ordering.order_general,
  allSubscriptionsData:
    state.onboarding && state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  update_new_subscription_taxes_data,
  update_ordering_subscription_taxes,
})(withRouter(EditFastFoodGeneralSettingsTaxes));
